module.exports = __webpack_public_path__ + "img/1-09.1abd69ee.png";